import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import TrackingCheckoutDetailsComponent from "@/pages/tracking/components/TrackingCheckoutComponents/TrackingCheckoutDetailsComponent/TrackingCheckoutDetailsComponent";
import { useTranslation } from "@i18n";
import Loader from "@componentsShared/Loader/Loader";
import { api__getOrderTracking } from "@/apis/orderTracking/api__getOrderTracking";
import useApi from "@hooks/useApi";
import { api__getAllOfferedDoc } from "@/apis/orderTracking/offerdDocuments";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { getCurrentStep } from "@/pages/tracking/utls";
var TrackingCheckoutDetails = function TrackingCheckoutDetails() {
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useParams = useParams(),
    orderId = _useParams.orderId;
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(0),
    refreshKey = _useState[0],
    setRefreshKey = _useState[1];
  var _useApi = useApi([orderId], function () {
      return api__getAllOfferedDoc(orderId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    allOfferedDoc = _useApi2[2];
  var _useApi3 = useApi([orderId, refreshKey], function () {
      return api__getOrderTracking(orderId);
    }),
    _useApi4 = _slicedToArray(_useApi3, 3),
    loading2 = _useApi4[0],
    error2 = _useApi4[1],
    order = _useApi4[2];
  useEffect(function () {
    if (!__IS_CSR__) return;
    var isDirectLink = !document.referrer || !document.referrer.includes(window.location.hostname);
    if (isDirectLink) {
      trackEvents("order_tracking_entry", {
        referral_location: "direct_link",
        platform: getPlatformInfo()
      });
    }
  }, []);
  useEffect(function () {
    var _order$payment_type;
    if (!order) return;
    var currentStep = getCurrentStep(order);
    trackEvents("order_tracking_viewed", {
      order_id: order.id,
      tracking_category: "purchase",
      order_type: (_order$payment_type = order.payment_type) !== null && _order$payment_type !== void 0 ? _order$payment_type : "cash",
      order_step: currentStep ? currentStep.title : null,
      has_warranty: order.warrantyV2 !== null ? "yes" : "no"
    });
  }, [order === null || order === void 0 ? void 0 : order.id]);
  if (error || error2) return navigateTo("/page404", {
    ref: "order-not-found"
  });
  if (loading || loading2) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    mobileHasTitle: t("track_car_order", {
      ns: "web_tracking"
    }),
    hideOrangeHeadBtn: true,
    mobileHasBack: true,
    mobileNoLogo: true,
    headHideLinks: true,
    hideFooter: true,
    hideHeaderOnmobile: true,
    hideFooterWithoutAuthMsg: true
  }, order && /*#__PURE__*/React.createElement(TrackingCheckoutDetailsComponent, {
    key: order === null || order === void 0 ? void 0 : order.id,
    details: order,
    allOfferedDoc: allOfferedDoc,
    onRefreshOrder: function onRefreshOrder() {
      return setRefreshKey(function (k) {
        return k + 1;
      });
    }
  }));
};
export default TrackingCheckoutDetails;